import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  Chip,
  Divider,
  LinearProgress,
  Container,
  Button,
} from "@mui/material";
import * as React from "react";
import { useGo, useList } from "@refinedev/core";
import { Batch } from "../playground/types";
import { ArrowBack } from "@mui/icons-material";

export default function ClientBatches() {
  const go = useGo();

  const { data, isError, isLoading } = useList({
    resource: "batch",
    meta: {
      params: {
        client_owned_only: false,
      },
    },
  });

  const batches = (data?.data as Batch[]) || [];

  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: 4,
        mb: 4,
        flex: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => {
            go({
              to: "/profile",
            });
          }}
          variant="text"
          size="small"
        >
          Back
        </Button>

        <Typography variant="h6">Your batches</Typography>
      </Box>

      {isLoading && (
        <Box sx={{ width: "100%", mt: 2 }}>
          <LinearProgress />
        </Box>
      )}

      {isError && (
        <Typography color="error">
          Couldn't load batches, please retry!
        </Typography>
      )}

      {!isLoading && !isError && batches.length === 0 && (
        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            backgroundColor: "#f5f5f5",
          }}
        >
          <Typography variant="body1" color="text.secondary">
            No batches available at the moment.
          </Typography>
        </Paper>
      )}

      {batches.length > 0 && (
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            overflow: "hidden",
            border: "1px solid #e0e0e0",
          }}
        >
          <List sx={{ width: "100%", p: 0 }}>
            {batches.map((batch, index) => {
              const delivered = batch.client_jobs_to_go?.delivered || 0;
              const completed = batch.client_jobs_to_go?.completed || 0;
              const toBeReworked = batch.client_jobs_to_go?.to_be_reworked || 0;

              return (
                <React.Fragment key={batch.id}>
                  <ListItem
                    onClick={() => {
                      go({
                        to: `/review/${batch.id}`,
                      });
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1,
                      px: 2,
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f9f9f9",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "baseline",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">{batch.name}</Typography>
                      {batch.brand_name && (
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                          }}
                        >
                          {batch.brand_name}
                        </Typography>
                      )}
                    </Box>
                    <Chip
                      label={
                        <span>
                          {delivered} to check • {toBeReworked} to be reworked •{" "}
                          {completed} completed
                        </span>
                      }
                      color="primary"
                      sx={{
                        backgroundColor:
                          delivered > 0 || toBeReworked > 0
                            ? "#B00119"
                            : "#BDBDBD",
                        color: "#FFFFFF",
                        fontWeight: 500,
                        borderRadius: 2,
                      }}
                    />
                  </ListItem>
                  {index < batches.length - 1 && <Divider component="li" />}
                </React.Fragment>
              );
            })}
          </List>
        </Paper>
      )}
    </Container>
  );
}
